import { render, staticRenderFns } from "./smartptom-table.vue?vue&type=template&id=748c26fc&scoped=true"
import script from "./smartptom-table.vue?vue&type=script&lang=js"
export * from "./smartptom-table.vue?vue&type=script&lang=js"
import style0 from "./smartptom-table.vue?vue&type=style&index=0&id=748c26fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748c26fc",
  null
  
)

export default component.exports